import React from 'react';
import UserProfilePage from '../../user/pages/index';

const MainProfilePage: React.FC = () => {
  return <UserProfilePage />;
};

export default MainProfilePage;